import React__default from 'react';
import styled from 'styled-components';
import { themeGet } from '../../utils/theme-get.js';
import sx from '../../sx.js';

const labelStyles = {
  display: 'grid',
  gridAutoColumns: '1fr',
  gridAutoRows: 'min-content',
  color: 'text.default',
  cursor: 'default',
  fontFamily: 'normal'
};
const textLabelLayoutStyles = {
  gap: '0px 4px',
  gridTemplateColumns: 'min-content auto'
};
const StyledLabel = styled.label.withConfig({
  displayName: "AtlasCheckboxLabel__StyledLabel",
  componentId: "sc-yw2wo5-0"
})(["font-size:", ";", ""], p => {
  if (p.labelSize === 'default') return themeGet('fontSizes.3');
  if (p.labelSize === 'small') return '12px';
  return 'revert';
}, sx);
const AtlasCheckboxLabel = ({
  children,
  isDisabled,
  testId,
  onClick,
  label,
  labelSize = 'default',
  id
}) => {
  if (!label) return null;
  return /*#__PURE__*/React__default.createElement(StyledLabel, {
    sx: {
      ...labelStyles,
      ...textLabelLayoutStyles
    },
    "data-testid": testId,
    "data-disabled": isDisabled || undefined,
    onClick: onClick,
    labelSize: labelSize,
    id: id
  }, children);
};
AtlasCheckboxLabel.displayName = "AtlasCheckboxLabel";

export { AtlasCheckboxLabel };
